import { LitElement, html } from 'lit';

import { pageStyles } from '../../styles/shared/page.js';

class NotFoundPage extends LitElement {
  static styles = pageStyles;

  render() {
    return html`
      <header class="page-head">
        <div>
          <h1>Page not found</h1>
          <p class="lead">There is nothing at <code>${window.location.pathname}</code>.</p>
        </div>
      </header>
      <p><a href="/">Back to the start page</a></p>
    `;
  }
}

customElements.define('plane-not-found-page', NotFoundPage);
